import { useEffect } from 'react';
import HeaderMetedBase from './HeaderMetedBase';

import { connect, useDispatch } from 'react-redux'
import { getCatalog } from '../../actions'
import Loading from './Loading';
import LegalNotices from './LegalNotices';


function CatalogController(props) {
    const dispatch = useDispatch();
    const { viewer } = props

    useEffect(() => {
        dispatch(getCatalog());
    }, [dispatch]);

    if (viewer.catalog_initialized) {
        let content = [];
        
        return <BrowseContainer content={content} tabKey={props.tabKey} />

    } else {
        return <Loading />
    }

}

const BrowseContainer = (props) => {

    return (
        <div id='et-browse-container'>

            <HeaderMetedBase activePage="catalog" />
            <LegalNotices />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        viewer: state.viewer,
        user: state.user
    };
}

export default connect(mapStateToProps)(CatalogController);